<div class="mb-3">
  @if (control().hasLabel) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  <div [class.billing-multi-column]="control().displayMultiColumn">
    @for (item of control().billingLineItemsValue; track item.date) {
      <div class="date-group">
        <h4 [style.color]="control().valueColour">{{ item.date }}</h4>
        <mat-list class="mat-list-dynamic">
          @for (proc of item.procedures; track proc.code) {
            <mat-list-item [style.color]="control().valueColour">
              @if (control().displayCodeDetails) {
                <span>{{ proc.code }} - {{ proc.description }}</span>
              } @else {
                <span>{{ proc.code }}</span>
              }
            </mat-list-item>
          }
        </mat-list>
      </div>
    }
  </div>
</div>
